import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { foreignServiceAddressNameFields } from 'constants/enums/people';
import { MilitaryForeignItemModel } from '../types';
import militaryForeignContactValidator from './contact';

const foreignOrganization = [
  'Military',
  'Intelligence',
  'Diplomatic',
  'Security',
  'Militia',
  'OtherDefense',
  'OtherGov',
];

const militaryForeignItemValidator: ValidateJSModel<MilitaryForeignItemModel> = {
  Organization: {
    hasValue: {
      validator: { inclusion: foreignOrganization },
    },
  },

  Name: { hasValue: true },

  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Rank: { hasValue: true },

  Division: { hasValue: true },

  Circumstances: { hasValue: true },

  ReasonLeft: (value, attributes) => {
    if (attributes?.Dates?.present) { return {}; }

    return { hasValue: true };
  },

  MaintainsContact: (value, attributes, attributeName, options) => {
    if (options?.requireForeignMilitaryMaintainsContact) {
      return {
        hasValue: { validator: hasYesOrNo },
      };
    }

    return {};
  },

  List: (value, attributes, attributeName, options) => {
    if (attributes?.MaintainsContact?.value === 'Yes') {
      let additionalValidation: any = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, foreignServiceAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.relatives.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: {
          validator: militaryForeignContactValidator,
        },
      };
    }

    return {};
  },
  Comments: {},
  ContactAnswerComments: {},
  ContactSummaryComments: {},
};

export default militaryForeignItemValidator;
